import produce from "immer";
import { ActionType, getType } from "typesafe-actions";
import { Key, State as LkfState } from "@linkfluence/core/state";
import close from "./close/action";
import open from "./open/action";

type State = LkfState[Key.Panel];

type Actions = ActionType<typeof open> | ActionType<typeof close>;

const reducer = (state: State = null, action: Actions) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case getType(open):
        return action.payload;
      case getType(close):
        return null;
    }
  });
};

export default reducer;
